/**
 * Created by jehe on 07.02.2019.
 */
/*global define, require, $, window, ol*/

/*jslint browser: true*/
import helptext from "./KPhelptextgenerator";
import mapTools from "./js/plugins/mapToolPlugin.js";
import mapWriterPlugin from "./js/plugins/mapWriterPlugin";
import layerspyPlugin from "./js/plugins/layerspyPlugin";
import layerSliderPlugin from "./js/plugins/layerSliderPlugin";
import attribution from "./js/plugins/attributionPlugin";
import layermenu from "./js/plugins/layermenuPlugin";
import baselayerSwitcher from "./js/plugins/baselayerSwitcherPlugin";
import searchPlugin from "./js/plugins/searchPlugin";
import contextPlugin from "./js/plugins/contextMenuPlugin.js";
import topMenuPlugin from "./js/plugins/topMenuToolsPlugin";

import layerImportPlugin from "./js/plugins/layerImportPlugin.js";

("use strict");
var parameters, configs;
//var baseUrl = "//10.192.10.26/";
var baseUrl = "https://od2.pbe.oslo.kommune.no/";
var extraUrl = "https://od2.pbe.oslo.kommune.no/";
((parameters = {
  intranett: true,
  wfsTillegg: "&version=1.1.0&service=wfs&request=GetFeature",
  /** Kart-url'er */
  cacheurl: baseUrl + "tilecache",
  //phpAutocomplete: baseUrl + "php/kartinnsyn/",
  phpAutocomplete: "https://od2.pbe.oslo.kommune.no/noden/",
  //autocompleteUrl: baseUrl + "php/kartinnsyn/getAutocompleteData.php",
  autocompleteUrl:
    "https://od2.pbe.oslo.kommune.no/noden/getAutocompleteDataNoPlan",
  searchUrl: baseUrl + "cgi-bin/wms?map=WFS_SOK",
  kartinnsynurl: baseUrl + "cgi-bin/wms?map=KARTINNSYN",
  //geoJsonWFS: baseUrl + "cgi-bin/wms?map=PIGEOJSON",
  geoJsonWFS: baseUrl + "cgi-bin/wms?map=PI4_GEOJSON",
  tableWfs: baseUrl + "cgi-bin/wms?map=EIENDOM_TABELL&tabell=",
  mapcacheurl: baseUrl + "mapcache/wmts?",
  ki_forgrunnurl: baseUrl + "cgi-bin/wms?map=FORGRUNN",
  kommuneplanurl: baseUrl + "cgi-bin/wms?map=KOMMUNEPLAN",
  vannBekkerEleverurl: baseUrl + "cgi-bin/wms?map=VANN_NY",
  flyfotoUrl: baseUrl + "/cgi-bin/wms?map=FLYFOTO",
  flyfotoTextUrl: baseUrl + "cgi-bin/wms?map=TEKST_FLYFOTO",
  planmetaWSUrl:
    "https://od2.pbe.oslo.kommune.no/noden/Planmetadata/planmetadata?",
  bakgrunnGraaUrl: baseUrl + "cgi-bin/wms?map=BAKGRUNN",
  smaahusUrl: baseUrl + "cgi-bin/wms?map=SMAAHUS",
}),
  (configs = {
    minZoom: 11,
    mapTools: [
      //Måle areal
      {
        id: "measure-area-small",
        className: "area-btn measure-btn",
        toolTip: "Mål areal",
        buttonText: "Mål areal",
        iconType: "text",
        icon: "m²",
        onclick: "measureAreaClick",
        register: function (registerFunction, callback) {
          mapTools.registerAreaMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-area-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Måle lengde
      {
        id: "measure-length-small",
        className: "length-btn measure-btn",
        toolTip: "Mål avstand",
        buttonText: "Mål avstand",
        iconType: "icon",
        icon: "icon-measure",
        onclick: "measureLengthClick",
        register: function (registerFunction, callback) {
          mapTools.registerLengthMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-length-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Tegne
      {
        id: "make-sketch-small",
        className: "sketch-btn",
        toolTip: "Lag tegninger",
        buttonText: "Lag tegninger",
        iconType: "icon",
        icon: "fa fa-pencil",
        onclick: "drawClick",
        register: function (registerFunction, callback) {
          mapTools.registerDrawPlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik tegner du",
          id: "make-sketch-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene i tegningen.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en tegning.",
            'Slett tegningene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Zoom helt ut
      {
        id: "zoom-full-small",
        className: "map-eraser-btn",
        toolTip: "Zoom til hele Oslo",
        buttonText: "Zoom helt ut",
        iconType: "icon",
        icon: "glyphicon glyphicon-globe",
        onclick: "zoomFullClick",
      },
      //Fjern markeringer
      {
        id: "map-eraser-small",
        className: "map-eraser-btn",
        toolTip: "Fjern markeringer av eiendommer og planer i kartet",
        buttonText: "Fjern markeringer",
        iconType: "icon",
        icon: "glyphicon glyphicon-erase",
        onclick: "eraserClick",
      },
      //Skrive på kartet
      {
        id: "text-on-map",
        className: "write-btn",
        toolTip: "Skriv på kartet",
        buttonText: "Skriv på kartet",
        iconType: "icon",
        icon: "fa fa-font",
        onclick: "mapWriterClick",
        register: function (registerFunction, callback) {
          mapWriterPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      //Kikkehull
      {
        id: "layer-spy",
        className: "point-search-btn",
        toolTip: "Se på underliggende kartlag med kikkehullet",
        buttonText: "Kikkehull",
        iconType: "icon",
        icon: "icon-Kikkehull",
        touchSensitive: true,
        onclick: "spyClick",
        parameters: "flyfoto",
        register: function (registerFunction, callback) {
          layerspyPlugin.registerPluginFunction(registerFunction, callback);
        },
        toolHelp: {
          header: "Kikkehull",
          id: "layer-spy-tool-help",
          steps: [
            "Bruk musepekeren til å se på flyfoto under kartet.",
            "Bruk piltast opp eller ned for å gjøre kikkehullet større eller mindre",
          ],
        },
      },
      //Lagslider
      {
        id: "layer-slider",
        className: "slider-btn",
        toolTip:
          "Bruk slideren til å skjule deler av kartlaget eller gjøre det mer gjennomsiktig.",
        buttonText: "Slide",
        iconType: "icon",
        icon: "fa fa-sliders",
        onclick: "mapSliderClick",
        register: function (registerFunction, callback) {
          layerSliderPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      //Lagimport
      {
        id: "layer-import",
        className: "import-btn",
        toolTip: "Dra og slipp for å importere",
        buttonText: "Import",
        iconType: "icon",
        icon: "fa fa-upload",
        onclick: "importClick",
        register: function (registerFunction, callback) {
          layerImportPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
    ],
    topMenu: [],
    baseLayers: [
      {
        olType: "group",
        layerId: "baselayers",
        displayInLayerMenu: false,
        layers: [
          {
            olType: "wmts",
            title: "Bakgrunnskart",
            layerId: "bakgrunn",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_graa",
            visible: true,
            dependent: "text1",
            displayInLayerMenu: false,
            altSource: {
              url: parameters.bakgrunnGraaUrl,
              layerName: "bakgrunn_graa",
            },
          },
          {
            olType: "wmts",
            layerId: "flyfoto",
            title: "Flyfoto",
            url: parameters.mapcacheurl + "map=FLYFOTO",
            layerName: "flyfoto",
            dependent: "text2",
            altSource: {
              url: parameters.flyfotoUrl,
              layerName: "nyeste_flyfoto_bg_hvit",
              epsg: "EPSG:32632",
            },
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m (flyfoto)",
            layerId: "text2",
            url: parameters.flyfotoTextUrl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            displayInLayerMenu: false,
            visible: false,
          },
        ],
      },
    ],
    layermenuLayers: [
      {
        olType: "image",
        title: "Arealformål",
        layerId: "kp_pk1-2_arealformaal",
        url: parameters.smaahusUrl,
        layerName: "arealformaal",
        visible: true,
      },
      {
        olType: "group",
        title: "Hensynssoner",
        layerId: "hensynssoner",
        groupCheckbox: true,
        visible: false,
        layers: [
          {
            olType: "group",
            title: "Sikringssoner for anlegg i grunnen",
            layerId: "sikringssoner",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Sikringssone for anlegg i fjell H190_1",
                layerId: "H190_1",
                url: parameters.smaahusUrl,
                layerName: "H190_1",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for vannforsyningsnett H190_2",
                layerId: "H190_2",
                url: parameters.smaahusUrl,
                layerName: "H190_2",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for vanntunnel H190_3",
                layerId: "H190_3",
                url: parameters.smaahusUrl,
                layerName: "H190_3",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for vannforsyning H190_4-5",
                layerId: "H190_4-5",
                url: parameters.smaahusUrl,
                layerName: "H190_4-5",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for jernbaneanlegg H190_6-7",
                layerId: "H190_6-7",
                url: parameters.smaahusUrl,
                layerName: "H190_6-7",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for T-banetunneler H190_8",
                layerId: "H190_8",
                url: parameters.smaahusUrl,
                layerName: "H190_8",
                visible: false,
              },
              {
                olType: "image",
                title: "Sikringssone for vei- og banetunneler H190_9-11",
                layerId: "H190_9-11",
                url: parameters.smaahusUrl,
                layerName: "H190_9-11",
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            title: "Faresoner – ras og skredfare",
            layerId: "faresonerRas",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Faresone – områdestabilitet H310_1",
                layerId: "H310_1",
                url: parameters.smaahusUrl,
                layerName: "H310_1",
                visible: false,
              },
              {
                olType: "image",
                title: "Faresone – stensprang H310_2",
                layerId: "H310_2",
                url: parameters.smaahusUrl,
                layerName: "H310_2",
                visible: false,
              },
              {
                olType: "image",
                title: "Faresone – snøskred H310_3",
                layerId: "H310_3",
                url: parameters.smaahusUrl,
                layerName: "H310_3",
                visible: false,
              },
              {
                olType: "image",
                title: "Faresone – jord og flomskred H310_4",
                layerId: "H310_4",
                url: parameters.smaahusUrl,
                layerName: "H310_4",
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            title: "Faresoner – flomfare",
            layerId: "faresonerFlom",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Faresone – vassdragsflom H320_1",
                layerId: "H320_1",
                url: parameters.smaahusUrl,
                layerName: "H320_1",
                visible: false,
              },
              {
                olType: "image",
                title: "Faresone – stormflo H320_2",
                layerId: "H320_2",
                url: parameters.smaahusUrl,
                layerName: "H320_2",
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            title: "Hensyn - grønnstruktur",
            layerId: "RpAngitthensynsone",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Hovedvassdrag",
                layerId: "H540_1",
                url: parameters.smaahusUrl,
                layerName: "H540_1",
                visible: false,
              },
              {
                olType: "image",
                title: "Sidevassdrag",
                layerId: "H540_2",
                url: parameters.smaahusUrl,
                layerName: "H540_2",
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            title: "Båndleggingssone",
            layerId: "bandleggingssone",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Båndlegging etter lov om kulturminner H730",
                layerId: "H730",
                url: parameters.smaahusUrl,
                layerName: "H730",
                visible: false,
              },
              {
                olType: "image",
                title: "Båndlegging etter energiloven H740",
                layerId: "H740",
                url: parameters.smaahusUrl,
                layerName: "H740",
                visible: false,
              },
            ],
          },
        ],
      },
      {
        olType: "group",
        title: "Bestemmelsesområder",
        layerId: "bestemmelsesomrade",
        groupCheckbox: true,
        visible: false,
        layers: [
          {
            olType: "image",
            title:
              "Bestemmelsesområde for plassering av tiltak nær formelt vernet bygning ",
            layerId: "bestemmelse1",
            url: parameters.smaahusUrl,
            layerName: "bestemmelse1",
            visible: false,
          },
          {
            olType: "image",
            title: "Bestemmelsesområde for automatisk fredete kulturminner",
            layerId: "bestemmelse3",
            url: parameters.smaahusUrl,
            layerName: "bestemmelse3",
            visible: false,
          },
          {
            olType: "image",
            title: "Bestemmelsesområde for lukkede vassdrag",
            layerId: "bestemmelse2",
            url: parameters.smaahusUrl,
            layerName: "bestemmelse2",
            visible: false,
          },
        ],
      },
      {
        olType: "group",
        layerId: "kartdetaljer",
        title: "Detaljer",
        collapsible: true,
        groupCheckbox: false,
        altTarget: "fkb",
        layers: [
          {
            olType: "wmts",
            title: "Bygninger, veier, koter m.m.",
            layerId: "situasjon",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_linjer",
            altSource: {
              url: parameters.ki_forgrunnurl,
              layerName: "Forgrunn",
              epsg: "EPSG:32632",
            },
            noToggle: true,
            visible: true,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m.",
            layerId: "text1",
            url: parameters.ki_forgrunnurl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            conditional: { condition: "flyfoto", trigger: "text2" },
            noToggle: true,
            visible: true,
          },
          {
            olType: "group",
            layerId: "eiendomsgrenser",
            title: "Eiendomsgrenser",
            collapsible: true,
            layerInfo: true,
            customLayerInfo:
              "<h3>Eiendomsgrenser</h3><br /><h4>Tegnforklaring:</h4><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-landmaalt'>&nbsp;</div><div class='legend-text'>Landmålt grense</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-seksjonsgrense'>&nbsp;</div><div class='legend-text'>Seksjonsgrense</div></div><div class='legend-row'><div class='legend-symb legend-anleggseiendommer'>&nbsp;</div><div class='legend-text'>Anleggseiendom</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-usikker'>&nbsp;</div><div class='legend-text'>Ikke landmålt/usikker grense</div></div>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Eiendomsgrenser",
                layerId: "eiendom",
                layerInfo: false,
                url: parameters.mapcacheurl,
                layerName: "eiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
              {
                olType: "image",
                layerId: "eiendomText",
                title: "eiendomsText",
                url: parameters.kartinnsynurl,
                layerName: [
                  "Fkb_eiendom_tekst_piv5",
                  "Fkb_eiendom_informasjonspil_piv5",
                ],
                zIndex: 100,
                dependent: "eiendom",
                displayInLayerMenu: false,
                visible: false,
              },
              {
                olType: "image",
                title: "Anleggseiendommer",
                layerId: "Anleggseiendom",
                layerInfo: false,
                url: parameters.kartinnsynurl,
                layerName: "Anleggseiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Bydel",
            layerId: "bydel",
            url: parameters.kartinnsynurl,
            layerName: "Bydelsgrenser",
            visible: false,
          },
        ],
      },
    ],
    fkbLayers: false,
    modes: [],
    search: {
      autocompleteUrl: parameters.autocompleteUrl,
      autocompleteHandlers: [
        { key: "gate", func: "lookupAdresserForGate" },
        { key: "plan", func: "getLookupPlan" },
        { key: "stedsnavn", func: "getLookupStedsnavn" },
      ],
      ariaLabel:
        "Skriv inn adresse, gårds- og bruksnummer, plannummer eller saksnummer",
      placeholder: "Søk på adresse, gnr./bnr.",
    },
    mapInteractions: {
      featureHover: true,
      featureClick: false,
    },
    contextMenu: {
      disableMapClick: true,
    },
    //Tipsboks. TipId settes som cookie for å ikke vise boksen igjen.
    activeTip: true,
    tipText:
      "Småhusplanen er en reguleringsplan som gir føringer for videreutvikling av eiendommene i store deler av Oslos småhusområder. I perioden 22. juni - 31. august er endringer i planen på høring, Du finner mer informasjon på https://innsyn.pbe.oslo.kommune.no/sidinmening/. ",
    tipId: "smaahus",
  }));

// Legg til ekstra css-filer
//$("head").append("<link rel='stylesheet' type='text/css' href='css/foo.css'>");

//Titlelink setter lenke for oslologo + planinnsyn. Går til seg selv hvis den ikke er satt.
export default {
  intranett: true,
  site: {
    title: " |&nbsp;&nbsp; Småhusplanen",
    titleLink: "",
  },
  loadplugins: function (map, callback) {
    attribution.initiate({
      parent: "footerId",
      id: "copy-pbe",
      text: "©Oslo PBE",
      aria: "vis informasjon om vilkår for bruk av tjenesten",
      article:
        " <p>Plan- og bygningsetaten ønsker å levere data av høy kvalitet, men kan ikke garantere at innholdet i tjenesten er uten feil og mangler.</p> <p>Et reguleringsplankart er en sammenstilling av alle planforslag og gjeldende reguleringsplaner, og sammenstillingen er ikke juridisk bindende.</p> <p>Kart og eiendomsinformasjon er beskyttet etter åndsverkloven.</p>",
    });
    layermenu.initiate(configs.layermenuLayers, "Velg kartlag");
    baselayerSwitcher.initiate(
      document.getElementById("mapmenu"),
      map,
      "bakgrunn",
      "flyfoto",
      "./img/bakgrunnskart.min.png",
      "./img/flyfoto.min.jpg",
    );
    searchPlugin.initiate(configs.search);
    topMenuPlugin.initiate(configs.topMenu, parameters.intranett);
    callback();
  },
  customClickTriggers: [],
  parameters: parameters,
  configs: configs,
};
